class FirehawkCRMStockDetail {

  container = null;
  addingToCart = false;
  stockSlug = null;
  cartSlug = null;

  baseStockId = null
  variantId = null

  meta = {}

  variationViews = {}
  variationImages = {}
  fetchingVariation = false
  activeStockId = null

  constructor(element) {
		this.container = element
		this.addListeners()
    this.configureForm()

    this.baseStockId = this.container.data("stock")
    this.variantId = this.container.data("variant")
    if (!this.variantId || !this.variantId.length) {
      this.variantId = null
    }
    this.activeStockId = this.variantId || this.baseStockId

    if (this.activeStockId) {
      var content = this.container.find('.fh-stock-info-col').clone()
      content.find(".select2.select2-container").remove()
      this.variationViews[this.activeStockId] = content.html()
      this.variationImages[this.activeStockId] = jQuery(this.container).find("#fh-stock-primary-image-wrapper .fh-stock-primary-image").attr("src")
    }
	}

  addListeners() {
    this.container.delegate(".fh-add-to-cart", 'click', (event) => {
      event.preventDefault()
      var current = jQuery(event.currentTarget);
      let stockId = current.data("stock");
      this.addToCart(stockId, current);
    });

    this.container.delegate(".quantity-picker .subtract-button", "click", (event) => {
      let quantityField = jQuery(this.container).find(".quantity-picker #quantity")
      let quantity = quantityField.text()
      if (!quantity) {
        quantity = 1
      } else {
        quantity = +quantity
      }
      if (quantity > 1) {
        quantity -= 1
      }

      quantityField.text(quantity)
    })

    this.container.delegate(".quantity-picker .add-button", "click", (event) => {
      let quantityField = jQuery(this.container).find(".quantity-picker #quantity")
      let quantity = quantityField.text()
      if (!quantity) {
        quantity = 1
      } else {
        quantity = +quantity
      }

      quantity += 1
      quantityField.text(quantity)
    })

    this.container.delegate(".fh-stock-variation-products .fh-variation-product", "click", (event) => {
      let gridItem = jQuery(event.currentTarget)
      let stockId = gridItem.data("id");
      if (stockId) {
        this.loadStockVariation(stockId)
      }
    })

    this.container.delegate('.fh-stock-attribute-form select', 'change', (event) => {
        let current = jQuery(event.currentTarget);
        let fieldId = jQuery(current).attr('id');
        let fieldValue = jQuery(current).val();
        if(fieldId) {
          this.meta[fieldId] = fieldValue;
        }
    });

    this.container.delegate('.fh-stock-attribute-form textarea', 'change', (event) => {
        let current = jQuery(event.currentTarget);
        let fieldId = jQuery(current).attr('id');
        let fieldValue = jQuery(current).val();
        if(fieldId) {
          this.meta[fieldId] = fieldValue;
        }
    });

    this.container.delegate('.fh-stock-attribute-form input', 'change', (event) => {
        let current = jQuery(event.currentTarget);
        let fieldId = jQuery(current).attr('id');
        let fieldValue = jQuery(current).val();
        if (fieldId) {
          this.meta[fieldId] = fieldValue;
        }
    });

    this.container.delegate('#fh-download-product-sheet', 'click', (event) => {
      let current = jQuery(event.currentTarget);
      this.downloadProductSheet(current)
  });
  }

  downloadProductSheet(button) {
    var productSheetId = jQuery(button).data("product-sheet")

    if (!productSheetId || !productSheetId.length || jQuery(button).hasClass("loading")) {
      return
    }

    jQuery(button).addClass("loading")

    var params = {
      documentId: productSheetId,
      stockId: this.activeStockId
    }

    jQuery.ajax({
      method: 'post',
      url: ajax_var.url,
      data: {
        action: 'download_product_sheet',
        params: params
      }
    }).done((response) => {
      if (response && response.downloadUrl) {
        fetch(response.downloadUrl)
          .then(r => r.blob())
          .then(b => {
            let blob = new Blob([b], {type: "application/pdf"})
            saveAs(blob, response.fileName);
            jQuery(button).removeClass("loading")
          }).catch((e) => {
            jQuery(button).removeClass("loading")
          })
      } else {
        jQuery(button).removeClass("loading")
      }
    }).fail(() => {
      jQuery(button).removeClass("loading")
    }).always(() => {
      
    })
  }

  configureForm() {
    var me = this;
    this.meta = {}
    this.container.find(".select2-api").each(function() {
      var current = jQuery(this);
      let filterCategory = current.data("filter-category");
      let objectType = current.data("object-type");
      let displayImageInPicker = current.data("display-image") == true;
      let displayTitleInPicker = current.data("display-title") == true;
      let disableSearch = current.data("disable-search") == true;

      var theme = "bootstrap4"
      if (disableSearch) {
        theme += " select2-disable-search"
      }

      jQuery(current).select2({
        theme: theme,
        allowClear: true,
        placeholder: "Please Select",
        closeOnSelect: true,
        width: "100%",
        templateResult: function(data) {
          // return data.text
          return me.formatTemplateResults(data, displayImageInPicker, displayTitleInPicker)
          // var template = select.data("template") || null;
          // if (!template) return data.text
          // return formatTemplateResults(template, data)
        },
        ajax: {
          method: 'post',
          url: ajax_var.url,
          data: function (params) {
            return {
              action: 'fetch_fh_objects',
              params: {
                objectType: objectType,
                filterCategory: filterCategory,
                query: params.term ? '*'+params.term+'*' : null
              }
            }
          },
          processResults: function (dataR) {
            var data = JSON.parse(dataR);
            if(data && data.result) {
              let pickerRes = data.result;
              pickerRes = pickerRes.map((hit) => {
                  var newHit = {"id": hit.id || null, "text": hit.name, "source": hit};
                  return newHit;
                })
              return {
                results: pickerRes || []
              }
            }
            return {
              results: []
            }

          }
        }
      })
    })
  }

  formatTemplateResults(data, showImage, showTitle) {
    if (data && data.loading) {
      if (data.text == "Searching…") return "Fetching options…"
      return data.text
    }
    if(!data || !data.source) return data;

    let displayImage = data.source.displayImage || "https://firebasestorage.googleapis.com/v0/b/fcrm-e17b0.appspot.com/o/core%2Fimages%2Fstock-placeholder-icon.jpg?alt=media&token=59741ffe-6da9-4700-a7a6-74523bbbbbc0"
    let text = data.text;

    var elements = []
    if (showImage) {
      elements.push(`<div class="fh-picker-image"><img src="${displayImage}" /></div>`)
    }
    if (showTitle) {
      elements.push(`<div class="fh-picker-text">${text}</div>`)
    }
    if (!elements.length) {
      elements.push(`<div class="fh-picker-text">${text}</div>`)
    }
    return jQuery(`<div class="fh-picker-wrapper">${elements.join("")}</div>`);
  }

  addToCart(stock, currentTarget) {
    if (this.addingToCart) return;
    this.addingToCart = true

    jQuery(currentTarget).addClass("loading")

    let quantityField = jQuery(this.container).find(".quantity-picker #quantity")
    let quantity = quantityField.text() || 1

    var params = {
      stock: stock,
      quantity: quantity,
      meta: this.meta
    };

    if (this.baseStockId) {
      params.parentStock = this.baseStockId
    }

    jQuery.ajax({
      method: 'post',
      url: ajax_var.url,
      data: {
        action: 'add_to_cart',
        params: params
      }
    }).done((response) => {
      if (jQuery(this.container).find(".cart-success").length == 0 && this.cartSlug) {
        jQuery(`<div class="bd-callout bd-callout-success cart-success">Item added to cart. <a href="./${this.cartSlug}">View Cart</a></div>`).insertBefore(jQuery(this.container).find(".fh-stock-cart-footer"))
      }
    }).fail(() => {

    }).always(() => {
      jQuery(currentTarget).removeClass("loading")
      this.addingToCart = false
    })

  }

  loadStockVariation(stockId) {
    if (this.fetchingVariation) return;
    if (this.activeStockId == stockId) return;

    this.activeStockId = stockId
    this.updateStockDisplayImage(stockId)
    this.updateSelectedVariant()

    if (this.variationViews[stockId]) {
      jQuery(this.container).find(".fh-stock-info-col").html(this.variationViews[stockId])
      this.configureForm()
      return
    }

    this.fetchingVariation = true
    this.showStockInfoLoading(true)

    jQuery.ajax({
      method: 'post',
      url: ajax_var.url,
      data: {
        action: 'fetch_stock_variation_view',
        stock: stockId
      }
    }).done((response) => {
      if (response) {
        this.variationViews[stockId] = response
        jQuery(this.container).find(".fh-stock-info-col").html(response)
        this.configureForm()
      }
    }).fail(() => {

    }).always(() => {
      this.showStockInfoLoading(false)
      this.fetchingVariation = false
    })
  }

  updateStockDisplayImage(stockId) {
    let displayImageElement = jQuery(this.container).find("#fh-stock-primary-image-wrapper")

    if (this.variationImages[stockId]) {
      displayImageElement.find(".fh-stock-primary-image").attr("src", this.variationImages[stockId])
      return
    }

    displayImageElement.addClass("loading")

    jQuery.ajax({
      method: 'POST',
      url: ajax_var.url,
      data: {
        action: 'get_stock',
        stock: stockId
      }
    }).done((response) => {
      var displayImage = null
      if (response && response.stock) {
        displayImage = response.stock.displayImage
      }

      this.variationImages[stockId] = displayImage
      displayImageElement.find(".fh-stock-primary-image").attr("src", displayImage)
    }).fail(() => {

    }).always(() => {
      displayImageElement.removeClass("loading")
    })
  }

  showStockInfoLoading(loading) {
    if (loading) {
      jQuery('<div class="info-loading-view"><div class="inner"><span class="fcrms-spinner primary"></span><span>Fetching Info...</span></div></div>').appendTo(jQuery(this.container).find(".fh-stock-info-col"))
    } else {
      jQuery(this.container).find(".fh-stock-info-col .info-loading-view").remove()
    }
  }

  updateSelectedVariant() {
    var stockId = this.activeStockId
    jQuery(this.container).find(".fh-stock-variation-products .fh-variation-product").removeClass("selected")
    jQuery(this.container).find(".fh-stock-variation-products .fh-variation-product").each((index, item) => {
      var itemStockId = jQuery(item).data("id")
      if (itemStockId == stockId) {
        jQuery(item).addClass("selected")
      }
    })

  }

}
